/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateOrderRequest {
  billingAccountId: string;
  servicePointId: string;
  productKey: ProductKey;
}

export enum ProductKey {
  GAMEPASS = 'GAMEPASS',
}

export interface CreateOrderResponse {
  orderNumber: string;
  /** @format date-time */
  requestedCompletionDate: string;
}

export interface BuildInfo {
  group?: string;
  artifact?: string;
  version?: string;
  /** @format date-time */
  buildTime?: string;
}

export interface GitInfo {
  branch?: string;
  shortCommitId?: string;
  fullCommitId?: string;
  modified?: boolean;
  commitTime?: string;
  buildTime?: string;
  /** @format int64 */
  commitCount?: number;
}

export interface VersionInfo {
  nodeName?: string;
  startupTime?: string;
  buildInfo?: BuildInfo;
  gitInfo?: GitInfo;
}

export interface ShopStatus {
  enabled: boolean;
}

export enum BonusBandwidthStatus {
  ELIGIBLE_TO_GET_BONUS_BANDWIDTH = 'ELIGIBLE_TO_GET_BONUS_BANDWIDTH',
  INELIGIBLE_TO_GET_BONUS_BANDWIDTH = 'INELIGIBLE_TO_GET_BONUS_BANDWIDTH',
  HAS_BONUS_BANDWIDTH = 'HAS_BONUS_BANDWIDTH',
}

export interface Image {
  altText: string;
  url: string;
}

export enum PaymentType {
  MONTHLY = 'MONTHLY',
  INSTALLMENT_INTEREST_FREE = 'INSTALLMENT_INTEREST_FREE',
}

export interface Pricing {
  monthlyPrice: number;
  totalPriceForInstallmentPeriod?: number;
  /** @format int32 */
  numberOfMonthlyInstallments?: number;
  installationPrice: number;
  firstYearPrice: number;
  paymentType: PaymentType;
  deliveryRequired: boolean;
  creditCheckNeeded: boolean;
}

export interface Product {
  isAvailable: boolean;
  name: string;
  key: ProductKey;
  shortName?: string;
  description: SanityBlock[];
  details: SanityBlock[];
  mainImage: Image;
  videos: Video[];
  images: Image[];
  includedItems: string[];
  pricing: Pricing;
  purchaseStatus: PurchaseStatus;
}

export interface ProductsWithEligibility {
  purchaseEligibilityStatus: PurchaseEligibilityStatus;
  bonusBandwidthStatus?: BonusBandwidthStatus;
  products?: Product[];
}

export enum PurchaseEligibilityStatus {
  SUCCESS = 'SUCCESS',
  PURCHASE_RESTRICTION = 'PURCHASE_RESTRICTION',
  OPEN_ORDER = 'OPEN_ORDER',
  DUNNING = 'DUNNING',
  USER_ROLE = 'USER_ROLE',
}

export interface PurchaseStatus {
  alreadyOwned?: boolean;
  eligibleToPurchase: boolean;
}

export interface SanityBlock {
  markDefs?: SanityMarkDef[];
  style?: string;
  /** @format int32 */
  level?: number;
  listItem?: string;
  children: SanitySpan[];
  _type: string;
  _key?: string;
}

export interface SanityMarkDef {
  _type: string;
  _key: string;
  empty?: boolean;
  [key: string]: any;
}

export interface SanitySpan {
  marks?: string[];
  text: string;
  _type: string;
  _key?: string;
}

export interface Video {
  url: string;
  description: string;
  thumbnailUrl: string;
}

export interface Partner {
  id: string;
  name: string;
  siteUrl?: string;
  logoUrl?: string;
}

export interface Account {
  name?: string;
  customerId: string;
  partnerId: string;
}

export interface AccountInfo {
  userDetails: UserDetails;
  serviceLocations: ServiceLocation[];
}

export interface Address {
  id: string;
  streetAddress: string;
  streetAddress2?: string;
  postalCode?: string;
  dwellingUnitNumber?: string;
  city?: string;
  country?: string;
}

export interface ServiceLocation {
  /** @format int32 */
  siteId: number;
  integrationId: string;
  address: Address;
  services: string[];
}

export interface UserDetails {
  firstName: string;
  lastName: string;
  /** @format int32 */
  partnerNumber: number;
  customerNumber?: string;
  billingAccountId: string;
  crmId?: string;
  crmSystem?: string;
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || 'http://localhost:8080' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title Xbox Backend
 * @version 1.5.0-SNAPSHOT
 * @baseUrl http://localhost:8080
 * @contact Team Salgskanaler (https://wiki.altibox.net/pages/viewpage.action?pageId=66068893)
 *
 * Backend for Xbox app
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  orderController = {
    /**
     * No description
     *
     * @tags order-controller
     * @name CreateOrder
     * @request POST:/api/{partnerId}/order
     * @secure
     */
    createOrder: (partnerId: string, data: CreateOrderRequest, params: RequestParams = {}) =>
      this.request<CreateOrderResponse, any>({
        path: `/api/${partnerId}/order`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  authController = {
    /**
     * No description
     *
     * @tags auth-controller
     * @name Logout
     * @request POST:/api/auth/logout
     * @secure
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/logout`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  versionInfoController = {
    /**
     * No description
     *
     * @tags version-info-controller
     * @name GetVersion
     * @request GET:/info/version
     * @secure
     */
    getVersion: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/info/version`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags version-info-controller
     * @name GetCommitTime
     * @request GET:/info/time
     * @secure
     */
    getCommitTime: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/info/time`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags version-info-controller
     * @name GetCommitHash
     * @request GET:/info/hash
     * @secure
     */
    getCommitHash: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/info/hash`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags version-info-controller
     * @name GetDetails
     * @request GET:/info/details
     * @secure
     */
    getDetails: (params: RequestParams = {}) =>
      this.request<VersionInfo, any>({
        path: `/info/details`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  shopController = {
    /**
     * No description
     *
     * @tags shop-controller
     * @name GetShopStatus
     * @request GET:/api/shop/status
     * @secure
     */
    getShopStatus: (params: RequestParams = {}) =>
      this.request<ShopStatus, any>({
        path: `/api/shop/status`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags shop-controller
     * @name GetSellableProducts
     * @request GET:/api/shop/product
     * @secure
     */
    getSellableProducts: (
      query: {
        partnerId: string;
        billingAccountId: string;
        servicePointId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsWithEligibility, any>({
        path: `/api/shop/product`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  partnerController = {
    /**
     * No description
     *
     * @tags partner-controller
     * @name GetPartners
     * @request GET:/api/partner/available
     * @secure
     */
    getPartners: (params: RequestParams = {}) =>
      this.request<Partner[], any>({
        path: `/api/partner/available`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  accountController = {
    /**
     * No description
     *
     * @tags account-controller
     * @name GetCustomerAccount
     * @request GET:/api/account
     * @secure
     */
    getCustomerAccount: (params: RequestParams = {}) =>
      this.request<Account[], any>({
        path: `/api/account`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags account-controller
     * @name GetAccountInfo
     * @request GET:/api/account/info
     * @secure
     */
    getAccountInfo: (
      query: {
        partnerId: string;
        billingAccountId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccountInfo, any>({
        path: `/api/account/info`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
}
